import type { ReactNode } from "react";
import { Wordmark } from "./Wordmark";
import { AppFooter } from "./AppFooter";

/** Page shell: top bar with the wordmark, then a centred column. */
export function Page({
  children,
  right,
  width = "narrow",
  brand = "bar",
  footer = true,
}: {
  children: ReactNode;
  right?: ReactNode;
  width?: "narrow" | "wide";
  /** "center": the logo large and centred, as the page's title (the start screens). */
  brand?: "bar" | "center";
  /** false on the question screens (Edward, Nov 4): nothing under the answers but Continue. */
  footer?: boolean;
}) {
  const max = width === "wide" ? "max-w-[720px]" : "max-w-[480px]";
  return (
    <div className={`mx-auto flex min-h-dvh w-full ${max} flex-col px-5 pb-10`}>
      {brand === "center" ? (
        <header className="flex justify-center pt-10">
          <Wordmark size={36} />
        </header>
      ) : (
        <header className="flex min-h-14 items-center justify-between gap-3 pt-2">
          <Wordmark />
          {right ? <div className="text-[13px] text-muted">{right}</div> : null}
        </header>
      )}
      <main className="flex flex-1 flex-col">{children}</main>
      {footer ? <AppFooter /> : null}
    </div>
  );
}

/** A short, plain message screen (not found, errors, loading). */
export function Message({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <Page>
      <div className="mt-16">
        <h1 className="heading text-[30px] leading-[1.1]">{title}</h1>
        {children ? <div className="mt-4 text-[17px] leading-relaxed text-muted">{children}</div> : null}
      </div>
    </Page>
  );
}

export function Loading({ label = "Loading" }: { label?: string }) {
  return (
    <Page>
      <p role="status" className="mt-16 text-muted">
        {label}…
      </p>
    </Page>
  );
}
